// Ошибка экрана (задача D4): `ErrorBoundary` каждого раздела и корня.
//
// - Не загрузился ленивый кусок сборки — вышла новая версия пульта, а вкладка просит файлы старой: «Вышла новая
//   версия пульта» и «Обновить». Сами не перезагружаем: на экране могут быть несохранённые правки.
// - Другая ошибка — «Экран не открылся», текст ошибки и момент по МСК, который Влад найдёт в журнале.
import { RefreshCw, TriangleAlert } from 'lucide-react';
import { useState } from 'react';
import { isRouteErrorResponse, useRouteError } from 'react-router';
import { isChunkLoadError, messageRuOf } from '@/api/errors';
import { Button } from '@/components/ui/button';
import { formatMoment } from '@/lib/format';
import { WorkPanel } from './app-layout';
import { StateScreen } from './state-screen';

function reload(): void {
  window.location.reload();
}

function errorTextRu(error: unknown): string {
  if (isRouteErrorResponse(error)) return `Ошибка ${error.status}${error.statusText === '' ? '' : ` ${error.statusText}`}.`;
  return messageRuOf(error);
}

export function RouteError() {
  const error = useRouteError();
  const [moment] = useState(() => formatMoment(new Date()));

  if (isChunkLoadError(error)) {
    return (
      <StateScreen
        icon={RefreshCw}
        title="Вышла новая версия пульта"
        action={
          <Button size="lg" onClick={reload}>
            Обновить
          </Button>
        }
      >
        <p>Обновите страницу, чтобы продолжить.</p>
      </StateScreen>
    );
  }

  return (
    <StateScreen
      icon={TriangleAlert}
      title="Экран не открылся"
      action={
        <Button size="lg" onClick={reload}>
          Обновить страницу
        </Button>
      }
    >
      <p className="text-foreground">{errorTextRu(error)}</p>
      <p>Если повторится — пришлите Владу время: {moment}.</p>
    </StateScreen>
  );
}

/** Ошибка корня (не узнали, кто вошёл): та же ошибка, но в своей рамке — каркаса пульта ещё нет. */
export function RootRouteError() {
  return (
    <WorkPanel>
      <RouteError />
    </WorkPanel>
  );
}
